import { useState, useEffect } from 'react';
import { acquireToken } from '../authConfig';
import { trackError } from '../appinsights/applogs';
export default function useFetchForBuild(url, ref) {
  const [builData, setBuildData] = useState(null);
  const [buildError, setBuildError] = useState(null);
  const [buildLoading, setBuildLoading] = useState(true);
  useEffect(() => {
    acquireToken().then((response) => {
      if (ref.current) {
        (async () => {
          try {
            // Build headers with auth token if available
            const headers = {};
            if (response && response.accessToken) {
              headers.Authorization = 'Bearer ' + response.accessToken;
            }
            
            const res = await fetch(url, { headers });
            
            if (!res.ok) {
              throw new Error(`API Error ${res.status}: ${res.statusText}`);
            }
            
            const resJson = await res.json();
            setBuildData(resJson);
          } catch (err) {
            trackError(err);
            setBuildError(err);
          } finally {
            setBuildLoading(false);
          }
        })();
      }
      return () => {
        ref.current = false;
      };
    }).catch((err) => {
      trackError(err);
      setBuildError(err);
      setBuildLoading(false);
    });
  }, [url, ref]);
  return { builData, buildError, buildLoading };
}
